export default __webpack_public_path__ + "static/8_color-burn-493197290dc1b2d5a1644a79f48e3b53.png";